/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_NotificationMatrixTemplateDto } from '../models/PagedResultDto_NotificationMatrixTemplateDto';
import type { Wealthlane_NotificationService_DTOs_NotificationTemplate_ExportNotificationTemplateDto } from '../models/Wealthlane_NotificationService_DTOs_NotificationTemplate_ExportNotificationTemplateDto';
import type { Wealthlane_NotificationService_DTOs_NotificationTemplate_ExportNotificationTemplateRequestDto } from '../models/Wealthlane_NotificationService_DTOs_NotificationTemplate_ExportNotificationTemplateRequestDto';
import type { Wealthlane_NotificationService_DTOs_NotificationTemplate_NotificationMatrixTemplateDto } from '../models/Wealthlane_NotificationService_DTOs_NotificationTemplate_NotificationMatrixTemplateDto';
import type { Wealthlane_NotificationService_DTOs_NotificationTemplate_NotificationTemplateUpdateDto } from '../models/Wealthlane_NotificationService_DTOs_NotificationTemplate_NotificationTemplateUpdateDto';
import type { Wealthlane_NotificationService_DTOs_ResponseDto } from '../models/Wealthlane_NotificationService_DTOs_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NotificationTemplateService {

    /**
     * @param notificationTypeIds 
     * @param notificationMediumIds 
     * @param notificationCategories 
     * @param recipientTypes 
     * @param filter 
     * @param isActive 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_NotificationMatrixTemplateDto OK
     * @throws ApiError
     */
    public static getApiNotificationApiAppNotificationTemplate(
notificationTypeIds?: Array<string>,
notificationMediumIds?: Array<string>,
notificationCategories?: Array<string>,
recipientTypes?: Array<string>,
filter?: string,
isActive?: boolean,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_NotificationMatrixTemplateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/notification/api/app/notification-template',
            query: {
                'NotificationTypeIds': notificationTypeIds,
                'NotificationMediumIds': notificationMediumIds,
                'NotificationCategories': notificationCategories,
                'RecipientTypes': recipientTypes,
                'Filter': filter,
                'IsActive': isActive,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_NotificationService_DTOs_NotificationTemplate_NotificationMatrixTemplateDto OK
     * @throws ApiError
     */
    public static getApiNotificationApiAppNotificationTemplate1(
id: string,
): CancelablePromise<Wealthlane_NotificationService_DTOs_NotificationTemplate_NotificationMatrixTemplateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/notification/api/app/notification-template/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_NotificationService_DTOs_ResponseDto OK
     * @throws ApiError
     */
    public static putApiNotificationApiAppNotificationTemplate(
id: string,
requestBody?: Wealthlane_NotificationService_DTOs_NotificationTemplate_NotificationTemplateUpdateDto,
): CancelablePromise<Wealthlane_NotificationService_DTOs_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/notification/api/app/notification-template/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_NotificationService_DTOs_NotificationTemplate_ExportNotificationTemplateDto OK
     * @throws ApiError
     */
    public static postApiNotificationApiAppNotificationTemplateExportNotificationTemplates(
requestBody?: Wealthlane_NotificationService_DTOs_NotificationTemplate_ExportNotificationTemplateRequestDto,
): CancelablePromise<Wealthlane_NotificationService_DTOs_NotificationTemplate_ExportNotificationTemplateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/api/app/notification-template/export-notification-templates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_NotificationService_DTOs_ResponseDto OK
     * @throws ApiError
     */
    public static postApiNotificationApiAppNotificationTemplateImportNotificationTemplates(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_NotificationService_DTOs_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/api/app/notification-template/import-notification-templates',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
